import React, { useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Box,
  Button,
  Stack,
  Typography,
  DialogContentText,
} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { TableV2, CustomFilterV2, DialogDefaultV2 } from '../../../components/v2';
import * as selectorsControlePontos from '../../../store/controlePonto/reducer';
import * as actionsControlePontos from '../../../store/controlePonto/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Roles from '../../../constants/role';
import Formulario from './Formulario';

const DEFAULT_FILTER = { ativo: true };

const ControlePontoV2 = ({ controlePontoUsuarios, loadControlePontoUsuarios, authData, exportControlePonto }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState(DEFAULT_FILTER);
  const [openExport, setOpenExport] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const defaultFilterMemo = useMemo(() => ({ ...DEFAULT_FILTER }), []);

  const filterFields = useMemo(
    () => [
      {
        field: 'useAtivo',
        useAtivoLabel: 'Usuário Ativo',
        md: 12,
        xs: 12,
      },
      {
        field: 'useUsuarios',
        key: 'usuarioId',
        label: 'Usuário',
        multiSelect: true,
        md: 12,
        xs: 12,
        regimeTrabalhoIds: ['384aa79b-0ce2-4b45-9c55-ae20ec5c5e21'],
        ativo: localFilter.ativo,
      },
    ],
    [localFilter.ativo],
  );

  useEffect(() => {
    loadControlePontoUsuarios(localFilter);
  }, [loadControlePontoUsuarios]);

  const isAdmin = authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const onEdit = (rowId) => {
    setId(rowId);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setId(null);
    loadControlePontoUsuarios(localFilter);
  };

  const onConfirmExport = () => {
    exportControlePonto(localFilter, () => setOpenExport(false));
  };

  const columns = [
    {
      field: 'nome',
      headerName: 'Nome',
      flex: 1,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">{params.row.nome}</Typography>
          <Typography variant="body2" color="text.secondary">{params.row.matricula}</Typography>
        </Box>
      ),
    },
    {
      field: 'ativo',
      headerName: 'Ativo',
      flex: 0.4,
      valueGetter: (_, row) => (row.ativo ? 'Sim' : 'Não'),
    },
    { field: 'saldo', headerName: 'Saldo', flex: 0.4 },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Banco de Horas</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={controlePontoUsuarios || []}
          columns={columns}
          rowHeight={56}
          onEdit={isAdmin ? onEdit : undefined}
          headerActions={[
            {
              label: 'Exportar',
              onClick: () => setOpenExport(true),
              startIcon: <FileDownloadOutlinedIcon />,
              variant: 'outlined',
            },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          defaultFilter={defaultFilterMemo}
          appliedFilter={localFilter}
          fields={filterFields}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            loadControlePontoUsuarios(filterData);
            setOpenFilter(false);
          }}
        />
      </Stack>
      <Formulario id={id} open={open} onClose={onClose} />
      <DialogDefaultV2
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={onConfirmExport}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText>Deseja exportar todas as informações filtradas?</DialogContentText>
      </DialogDefaultV2>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  controlePontoUsuarios: selectorsControlePontos.getControlePontosUsuarios(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsControlePontos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ControlePontoV2);
